const QUICK_ACTION_OTHER_SERVICE_HISTORY_KEY = 'quickActionOtherServiceHistoryTarget';

const getPathname = (url) => {
    if (typeof window === 'undefined') return url;
    return new URL(url, window.location.origin).pathname;
};

export const markQuickActionOtherServiceHistory = (url) => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem(QUICK_ACTION_OTHER_SERVICE_HISTORY_KEY, getPathname(url));
};

export const isQuickActionOtherServiceHistory = (pathname) => {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage.getItem(QUICK_ACTION_OTHER_SERVICE_HISTORY_KEY) === pathname;
};

export const clearQuickActionOtherServiceHistory = (pathname) => {
    if (!isQuickActionOtherServiceHistory(pathname)) return;
    window.sessionStorage.removeItem(QUICK_ACTION_OTHER_SERVICE_HISTORY_KEY);
};
